// extracted by mini-css-extract-plugin
export default {"header":"KveH5odzqP7uN_cg7o6h","nutrient":"TXFXa4i00nLE1pqFLhgo"};